// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-57ccbf04] .ui-modal-content {\n  width: 500px;\n}\n.message[data-v-57ccbf04] {\n  font-size: 16px;\n  font-weight: 400;\n  color: #000000;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
